import React from 'react';
import { useTranslation } from 'react-i18next';

interface TermsConsentFieldsProps {
  accepted: boolean;
  onAcceptedChange: (value: boolean) => void;
  marketingImages: boolean;
  onMarketingImagesChange: (value: boolean) => void;
  /** Erro de validação do aceite (ex.: a API recusou sem o aceite). */
  error?: string;
  idPrefix?: string;
}

/**
 * LGPD: o aceite ativo dos Termos de Uso e da Política de Privacidade
 * (obrigatório, desmarcado por padrão) e, separado e opcional, a autorização
 * de uso das imagens geradas em portfólio/marketing. Os links abrem em outra
 * aba para não perder o que já foi preenchido.
 */
const TermsConsentFields: React.FC<TermsConsentFieldsProps> = ({ accepted, onAcceptedChange, marketingImages, onMarketingImagesChange, error, idPrefix = 'consent' }) => {
  const { t } = useTranslation('auth');
  const link = 'text-snapfy-accent-soft underline underline-offset-2 hover:text-snapfy-text-primary';

  return (
    <div className="flex flex-col gap-2.5">
      <label htmlFor={`${idPrefix}-terms`} className="flex items-start gap-2.5 text-xs leading-[1.5] text-snapfy-text-secondary cursor-pointer">
        <input
          id={`${idPrefix}-terms`}
          type="checkbox"
          checked={accepted}
          onChange={(e) => onAcceptedChange(e.target.checked)}
          required
          aria-invalid={!!error}
          className="mt-0.5 h-4 w-4 shrink-0 rounded border-snapfy-border accent-[#7063f7]"
        />
        <span>
          {t('legal.acceptPrefix')}{' '}
          <a href="/terms" target="_blank" rel="noopener" className={link}>
            {t('legal.terms')}
          </a>{' '}
          {t('legal.and')}{' '}
          <a href="/privacy" target="_blank" rel="noopener" className={link}>
            {t('legal.privacy')}
          </a>
          {t('legal.acceptSuffix')}
        </span>
      </label>
      {error && <p className="m-0 pl-6 text-xs text-snapfy-error">{error}</p>}
      <label htmlFor={`${idPrefix}-images`} className="flex items-start gap-2.5 text-xs leading-[1.5] text-snapfy-text-secondary cursor-pointer">
        <input
          id={`${idPrefix}-images`}
          type="checkbox"
          checked={marketingImages}
          onChange={(e) => onMarketingImagesChange(e.target.checked)}
          className="mt-0.5 h-4 w-4 shrink-0 rounded border-snapfy-border accent-[#7063f7]"
        />
        <span>{t('legal.marketingImages')}</span>
      </label>
    </div>
  );
};

export default TermsConsentFields;
